// extracted by mini-css-extract-plugin
module.exports = {"regulatoryHeader":"_04cb157","regulatoryText":"_38a4c83"};